import React from "react";
import PropTypes from "prop-types";
import NoResults from "../NoResults";

const NoResultsPage = ({ titles, hotelData, isRtl }) => {
  return (
    <NoResults
      NoResultsTitle={titles.NoSearchResultsTitle}
      NoResultsMessage={titles.NoSearchResultsMessage}
      emailTitle={titles.Email}
      emailAddress={hotelData.FromEmailAddress}
      phoneTitle={titles.Phone}
      phoneNumber={hotelData.HotelPhone}
      isRtl={isRtl}
    />
  );
};

NoResultsPage.propTypes = {
  isRtl: PropTypes.bool,
  titles: PropTypes.object.isRequired,
  hotelData: PropTypes.object.isRequired
};

export default NoResultsPage;



// WEBPACK FOOTER //
// ./src/components/common/NoResultsPage/NoResultsPage.js